import * as axios from 'axios';


class FileUploadService {
    uploadFile(file, targetUrl) {
        let formData = new FormData();
        formData.append("file", file);


        return axios.post(
            targetUrl,
            formData,
            { headers: { 'Content-Type': 'multipart/form-data' } }
        ).then(function (resp) {
            return resp;
        })
        .catch(function (ex) {
            return ex;
        });
    }
}

export default new FileUploadService();
